<template>
  <section v-if="currentPage === 'Page'" class="z-index-1 section-contact">
    <div class="entry-content">
      <div class="container">
        <div class="row">
          <div class="content-area col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <article class="post-box blog-post">
              <div v-html="editorImgSrcParse(siteContent.desc)" class="inner-post no-padding-top"></div>
            </article>
          </div>
        </div>
      </div>
    </div>
  </section>
  <component v-else :is="currentPage"></component>
</template>

<script>
import { defineAsyncComponent, defineComponent } from 'vue';
import UserInfo from 'components/Partial/UserInfo.vue';
import { PageStore } from 'stores/Page/Page.ts';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'Page',

  inject: ['siteContent'],

  components: { UserInfo },

  data() {
    return {
      currentPage: null,
      relatedPages: {
        'about-us': () => import('../AboutUs.vue'),
        'our-services': () => import('../OurServices.vue'),
        'free-a-quote': () => import('../FreeAQuote.vue'),
        faq: () => import('../FAQ.vue'),
      },
    };
  },

  setup() {
    const pageStore = PageStore();
    const { head, content } = storeToRefs(pageStore);

    return {
      siteAddress: head.value.title.siteAddress,
      siteContent: content.value,
    };
  },

  methods: {
    editorImgSrcParse(data) {
      return this.replaceAll(data, '$apiImagesUrl', `${this.siteAddress}/images`);
    },

    replaceAll(str, search, replacement) {
      return str.split(search).join(replacement);
    },
  },

  created() {
    if (Object.prototype.hasOwnProperty.call(this.relatedPages, this.siteContent.link)) {
      this.currentPage = defineAsyncComponent(this.relatedPages[this.siteContent.link]);
    } else {
      this.currentPage = 'Page';
    }
  },
});
</script>

<style lang="scss">
.app-page--title {
  font-size: 20px;
  font-weight: bold;
  line-height: 1;
  color: $secondary;
}

.content-area p {
  margin-bottom: 1rem !important;
}
</style>
